<template>
  <v-card
    flat
    plain
    rounded
    class="row-switch"
    :class="{ 'row-switch--dark': $vuetify.theme.dark }"
    :ripple="false"
    @click="toggle"
    >
    <div class="row-switch__content">
      <v-checkbox
        v-model="localValue"
        :ripple="false"
        inset
        dense
        plain
        hide-details
        class="row-switch__checkbox pl-2 pb-1"
        @click.stop
      />
      <span class="row-switch__label">
        {{ label }}
      </span>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "RowSwitch",

  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    }
  },

  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    }
  },

  methods: {
    toggle() {
      this.localValue = !this.localValue
    }
  }
}
</script>

<style scoped>
.v-card--link:before {
  background: none;
  border: none;
}
.row-switch {
  border-radius: 4px;
  border: 1px solid rgba(0,0,0, 0.19);
  padding: 4px 12px;
  cursor: pointer;
  background-color: #fff;
  height: 40px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.row-switch--dark {
  background-color: #1e1e1e;
  border-color: rgba(255, 255, 255, 0.38);
}

.row-switch__content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  width: 100%;
}

.row-switch__checkbox {
  align-self: center;
  margin-top: 0;
  margin-bottom: 0;
}

.row-switch__label {
  font-size: 14px;
  font-weight: 450;
  color: var(--v-secondaryText-base);
}

</style>